import { FILTER_TYPES } from 'components/FilterPod';

const filters = (accountOptions = []) => [
  {
    title: 'تاریخ',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',

    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
    disableDelete: true,
  },
  {
    title: 'نوع',
    label: 'نوع',
    keyName: 'type',
    id: 6185,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: STATUS_OPTIONS,
    },
  },
  {
    title: 'شناسه',
    label: 'شناسه',
    keyName: 'id',
    id: 6186,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'نام',
    label: 'نام',
    keyName: 'name',
    id: 6187,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'شماره حساب',
    label: 'شماره حساب',
    keyName: 'accountNumber',
    id: 6188,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'نام و نام خانوادگی',
    label: 'نام و نام خانوادگی',
    keyName: 'fullName',
    id: 6189,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },

];

export default filters;

const STATUS_OPTIONS = [
  {
    label: 'تنخواه دار',
    value: 'تنخواه گردان',
  },
  {
    label: 'تنخواه گردان',
    value: 'شعبه',
  },
];
